import React, { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { useForm } from "react-hook-form";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import calculateFinancialYears, {
  formatAmount,
} from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";

export default function CreateGRN() {
  const location = useLocation();
  const navigate = useNavigate();
  const selectAllRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSalaries, setSelectedSalaries] = useState([]);
  const [pagestates, setPageStates] = useState({
    siteId: "",
    userSalaryList: [],
    isLoadingUserSalary: false,
    assignedSites: [],
    salaryTicketDetails: {},
    EditData: null,
    staffType: "site",
  });

  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  // console.log("pageStates====>", pagestates);
  // console.log("location?.state?.data====>", location?.state?.data);
  // console.log("selectedSalaries====>", selectedSalaries);

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    const initialType = location?.state?.data?.site?.type === "office" ? "office" : "site";
    setPageStates((prev) => ({ ...prev, staffType: initialType }));
    getAssignedSites(initialType);
    if (location?.state?.data) {
      GetSalaryTicketDetail(location?.state?.data?.id);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      const originalMonthFormat = location?.state?.data?.month
        ? location?.state?.data?.month.split("/").reverse().join("-")
        : "";

      const initialType = location?.state?.data?.site?.type === "office" ? "office" : "site";
      GetMonthlyUserSalary(
        location?.state?.data?.site?.id,
        originalMonthFormat,
        initialType,
      );

      // Set form fields
      setTimeout(() => {
        setPageStates((prev) => ({
          ...prev,
          siteId: location?.state?.data?.site?.id,
        }));
        setValue("siteId", location?.state?.data?.site?.id);
        setValue("month", originalMonthFormat);
        setValue("description", location?.state?.data?.description);

        if (location?.state?.data?.site) {
          handleFinancialYearCalculation(location?.state?.data?.site);
        }
        if (location?.state?.data?.financialYear) {
          setActiveFinancialYear(location?.state?.data?.financialYear);
          setValue("financialYear", location?.state?.data?.financialYear);
        }
      }, 1000);
    }
  }, [pagestates?.siteId]);

  useEffect(() => {
    if (location?.state?.data) {
      if (pagestates?.salaryTicketDetails?.salaryticketitems?.length > 0) {
        const mappedSalaries =
          pagestates?.salaryTicketDetails?.salaryticketitems?.map((item) => ({
            userSalaryId: item?.userSalaryId,
            amount: Number(item?.amount),
          }));
        setSelectedSalaries(mappedSalaries);
      }
    }
  }, [pagestates?.salaryTicketDetails]);

  const getAssignedSites = (type = "site") => {
    const option = { method: "GET" };
    const url = `${apiUrl?.get_user_site}?pageSize=100&type=${type}`;
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({ ...prev, assignedSites: res?.data?.site }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetSalaryTicketDetail = (id) => {
    const API = apiUrl?.get_salary_ticket_detail + `salaryTicketId=${id}`;
    callApi(API, { method: "GET" }).then((res) => {
      if (res?.status === true) {
        setPageStates((prev) => ({ ...prev, salaryTicketDetails: res?.data }));
      }
    });
  };

  const GetMonthlyUserSalary = (siteId, month = moment().format("YYYY-MM"), staffType = pagestates.staffType) => {
    const startDate = moment(month, "YYYY-MM")
      .startOf("month")
      .format("YYYY-MM-DD");
    const endDate = moment(month, "YYYY-MM")
      .endOf("month")
      .format("YYYY-MM-DD");

    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_monthly_user_salary +
      `?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&userType=${staffType === "office" ? 1 : 0}`;
    setPageStates((pre) => ({
      ...pre,
      isLoadingUserSalary: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        isLoadingUserSalary: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.userSalary?.map((item) => ({
          ...item,
          netSalary: item?.["Net Salary"] ? item?.["Net Salary"] : 0,
        }));
        setPageStates((pre) => ({
          ...pre,
          userSalaryList: newData,
        }));
      }
    });
  };

  const handleFinancialYearCalculation = (siteData) => {
    const startDate = siteData?.startDate;
    const endDate = siteData?.endDate;

    let fyStartYear;
    const now = moment();
    const month = now.month() + 1;
    const year = now.year();

    if (!startDate || !endDate) {
      fyStartYear = month >= 4 ? year : year - 1;
      const currentFY = `${fyStartYear}-${fyStartYear + 1}`;
      setFinancialYears([currentFY]);
      setActiveFinancialYear(currentFY);
      setValue("financialYear", currentFY);
      return;
    }

    const fys = calculateFinancialYears(
      moment.utc(startDate).format("YYYY-MM-DD"),
      moment.utc(endDate).format("YYYY-MM-DD"),
    );

    setFinancialYears(fys);

    fyStartYear = month >= 4 ? year : year - 1;
    const currentFY = `${fyStartYear}-${fyStartYear + 1}`;

    const selectedFY = fys.includes(currentFY) ? currentFY : fys[0] || "";

    // If not editing, or if editing but we want to potentially reset/default if not set (though logic above handles edit data separately)
    // Actually, in Edit mode, we set value from data. Here we set default if no value.
    const currentValue = getValues("financialYear");
    if (!currentValue && !location?.state?.data) {
      setActiveFinancialYear(selectedFY);
      setValue("financialYear", selectedFY);
    }
  };

  const onSubmit = (data) => {
    if (selectedSalaries?.length === 0) {
      toast.error("Please select at least one employee.");
      return;
    }
    const totalAmount = selectedSalaries.reduce(
      (sum, item) => sum + Number(item.amount || 0),
      0,
    );
    const formattedMonth = data.month
      ? data.month.split("-").reverse().join("/")
      : "";
    const postData = {
      siteId: pagestates.siteId,
      month: formattedMonth,
      salaryTicketItem: selectedSalaries,
      totalAmount: totalAmount,
      description: data?.description,
      financialYear: activeFinancialYear,
      userType: pagestates.staffType === "office" ? 1 : 0,
    };

    // console.log("postData= = = = = =>", postData);

    const isUpdate = location?.state?.data;
    const api = isUpdate
      ? `${apiUrl.update_salary_ticket}?salaryTicketId=${location?.state?.data?.id}`
      : apiUrl.create_salary_ticket;
    const option = {
      method: "POST",
      data: postData,
    };

    setIsLoading(true);
    callApi(api, option).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(
          response?.message ||
          `${isUpdate ? "Updated" : "Created"} successfully.`,
        );
        navigate(-1);
      } else {
        toast.error(response?.message || "Something went wrong.");
      }
    });
  };

  useEffect(() => {
    if (!selectAllRef.current) return;
    const selectableCount =
      pagestates?.userSalaryList?.filter(isSalarySelectable).length;

    if (
      selectedSalaries.length > 0 &&
      selectedSalaries.length < selectableCount
    ) {
      selectAllRef.current.indeterminate = true;
    } else {
      selectAllRef.current.indeterminate = false;
      selectAllRef.current.checked =
        selectedSalaries.length === selectableCount;
    }
  }, [selectedSalaries, pagestates?.userSalaryList]);

  const isSalarySelectable = (item) => {
    const isEditMode = !!location?.state?.data;
    const ticketItems =
      pagestates?.salaryTicketDetails?.salaryticketitems || [];
    const isPartOfCurrentTicket = ticketItems.some(
      (t) => t.userSalaryId === item.userSalary?.id,
    );

    if (isEditMode) {
      if (isPartOfCurrentTicket) return true;
      if (item?.userSalary?.isSalaryTicketCreated) return false;
      return true;
    } else {
      return !item?.userSalary?.isSalaryTicketCreated;
    }
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Salary Ticket
            </h1>
          </div>
        </div>
        <form id="againstPO" onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Salary Type</label>
                    <select
                      className="form-select form-control"
                      value={pagestates.staffType}
                      disabled={location?.state?.data}
                      onChange={(e) => {
                        const newType = e.target.value;
                        setPageStates((prev) => ({
                          ...prev,
                          staffType: newType,
                          siteId: "",
                          userSalaryList: [],
                        }));
                        setValue("siteId", "");
                        setSelectedSalaries([]);
                        getAssignedSites(newType);
                      }}
                    >
                      <option value="site">Site Staff</option>
                      <option value="office">Office Staff</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      {pagestates.staffType === "office" ? "Office" : "Site"}
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("siteId", {
                        required: "This field is Required",
                        onChange: (e) => {
                          const siteId = e.target.value;
                          setPageStates((prev) => ({ ...prev, siteId }));
                          const selectedMonth =
                            getValues("month") || moment().format("YYYY-MM");
                          GetMonthlyUserSalary(siteId, selectedMonth);
                          setSelectedSalaries([]);

                          const selectedSite = pagestates.assignedSites.find(
                            (s) => String(s.site.id) === String(siteId),
                          );
                          if (selectedSite) {
                            handleFinancialYearCalculation(selectedSite.site);
                          }
                        },
                      })}
                      disabled={location?.state?.data}
                    >
                      <option value="" className="d-none text-muted">
                        Select {pagestates.staffType === "office" ? "Office" : "Site"}
                      </option>
                      {pagestates?.assignedSites?.length > 0 ? (
                        pagestates.assignedSites.map((item) => (
                          <option key={item?.site?.id} value={item?.site?.id}>
                            {item?.site?.name}
                          </option>
                        ))
                      ) : (
                        <option className="text-muted" value="">
                          No {pagestates.staffType === "office" ? "office" : "site"} available
                        </option>
                      )}
                    </select>
                    <ErrorMessage message={errors?.siteId?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year</label>
                    <select
                      className="form-select"
                      {...register("financialYear", {
                        required: "This field is Required",
                        onChange: (e) => {
                          setActiveFinancialYear(e.target.value);
                        },
                      })}
                      // disabled={!pagestates.siteId || !!location?.state?.data}
                      // CreatePurchaseRequest disables if !SiteId or !!EditData.
                      // CreateSalaryTicket EditData check is location?.state?.data
                      disabled={!pagestates.siteId || !!location?.state?.data}
                      value={activeFinancialYear}
                    >
                      {/* If activeFinancialYear is set but not in list (e.g. empty list initially), it might be weird. 
                             financialYears defaults to empty. 
                             CreatePurchaseRequest renders options from financialYears. */}
                      {financialYears?.map((fy) => (
                        <option key={fy} value={fy}>
                          {fy}
                        </option>
                      ))}
                    </select>
                    <ErrorMessage message={errors?.financialYear?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Month
                    </label>
                    <input
                      type="month"
                      className="form-control"
                      id="bDate"
                      defaultValue={moment().format("YYYY-MM")}
                      min={
                        activeFinancialYear
                          ? `${activeFinancialYear.split("-")[0]}-04`
                          : ""
                      }
                      max={
                        activeFinancialYear
                          ? (() => {
                            const fyEnd = `${activeFinancialYear.split("-")[1]
                              }-03`;
                            const current = moment().format("YYYY-MM");
                            return moment(fyEnd).isBefore(current)
                              ? fyEnd
                              : current;
                          })()
                          : moment().format("YYYY-MM")
                      }
                      {...register("month", {
                        required: "This field is Required",
                        validate: (value) => {
                          if (!activeFinancialYear) return true;
                          const [start, end] = activeFinancialYear.split("-");
                          const min = `${start}-04`;
                          const max = `${end}-03`;
                          if (value < min || value > max) {
                            return `Month must be in financial year ${activeFinancialYear}`;
                          }
                          return true;
                        },
                        onChange: (e) => {
                          const selectedMonth = e.target.value;
                          const siteId = getValues("siteId");
                          if (siteId) {
                            GetMonthlyUserSalary(siteId, selectedMonth);
                          } else {
                            toast.info("Please select site first!");
                          }
                          setSelectedSalaries([]);
                        },
                      })}
                      disabled={location?.state?.data}
                    />
                    <ErrorMessage message={errors?.month?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-12">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div>

                {pagestates?.userSalaryList?.length > 0 && (
                  <div className="mt-4 w-100">
                    <div className="card shadow rounded-4 border-0">
                      <div className="card-header bg-primary text-white rounded-top-4">
                        <h5 className="mb-0 d-flex align-items-center">
                          <i className="bi bi-cash-coin me-2 fs-4"></i>
                          Employee Salary Summary
                        </h5>
                      </div>

                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover mb-0 align-middle">
                            <thead className="bg-light text-center">
                              <tr className="fw-semibold">
                                <th className="text-center">
                                  <input
                                    type="checkbox"
                                    ref={selectAllRef}
                                    className="form-check-input border border-dark rounded fs-4"
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        const allSelectable =
                                          pagestates?.userSalaryList
                                            ?.filter(isSalarySelectable)
                                            .map((item) => ({
                                              userSalaryId: item.userSalary?.id,
                                              amount:
                                                Number(
                                                  item?.["Net Salary"] ||
                                                  item?.netSalary,
                                                ) || 0,
                                            }));
                                        setSelectedSalaries(allSelectable);
                                      } else {
                                        setSelectedSalaries([]);
                                      }
                                    }}
                                  />
                                </th>

                                <th>Employee Code</th>
                                <th>Employee Name</th>
                                <th className="text-end">Net Pay</th>
                              </tr>
                            </thead>

                            <tbody>
                              {pagestates?.userSalaryList?.map((item, i) => {
                                const isDisabled = (() => {
                                  const isEditMode = !!location?.state?.data;
                                  const ticketItems =
                                    pagestates?.salaryTicketDetails
                                      ?.salaryticketitems || [];
                                  const isPartOfCurrentTicket =
                                    ticketItems.some(
                                      (t) =>
                                        t.userSalaryId === item.userSalary?.id,
                                    );

                                  if (isEditMode) {
                                    // Editing mode
                                    if (isPartOfCurrentTicket) return false;
                                    if (item?.userSalary?.isSalaryTicketCreated)
                                      return true;
                                    return false;
                                  } else {
                                    // Create mode
                                    return item?.userSalary
                                      ?.isSalaryTicketCreated;
                                  }
                                })();

                                const isChecked = selectedSalaries.some(
                                  (s) => s.userSalaryId === item.userSalary?.id,
                                );

                                const handleCheckboxChange = (e) => {
                                  if (e.target.checked) {
                                    setSelectedSalaries((prev) => [
                                      ...prev,
                                      {
                                        userSalaryId: item.userSalary?.id,
                                        amount:
                                          Number(
                                            item?.["Net Salary"] ||
                                            item?.netSalary,
                                          ) || 0,
                                      },
                                    ]);
                                  } else {
                                    setSelectedSalaries((prev) =>
                                      prev.filter(
                                        (s) =>
                                          s.userSalaryId !==
                                          item.userSalary?.id,
                                      ),
                                    );
                                  }
                                };

                                return (
                                  <tr
                                    key={i}
                                    className={`${isDisabled ? "bg-light text-muted" : ""
                                      }`}
                                  >
                                    <td className="text-center">
                                      <input
                                        type="checkbox"
                                        className={
                                          isDisabled
                                            ? "form-check-input rounded fs-4"
                                            : "form-check-input border border-dark rounded fs-4"
                                        }
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                        disabled={isDisabled}
                                      />
                                    </td>
                                    <td>
                                      {item?.employeeCode}
                                      {isDisabled && (
                                        <span className="badge rounded-5 bg-success ms-2">
                                          Created
                                        </span>
                                      )}
                                    </td>
                                    <td>{item?.name}</td>
                                    <td className="text-end text-success fw-medium">
                                      {formatAmount(
                                        item?.["Net Salary"] ||
                                        item?.netSalary ||
                                        0,
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}

                              <tr className="bg-gradient bg-primary text-white fw-bold">
                                <td> {selectedSalaries?.length}</td>
                                <td className="text-start">
                                  {" "}
                                  Selected Employee{" "}
                                </td>
                                <td className="text-end">Total Amount</td>
                                <td className="text-end">
                                  {formatAmount(
                                    selectedSalaries.reduce(
                                      (sum, item) => sum + item.amount,
                                      0,
                                    ),
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? (
                    <Spinner />
                  ) : location?.state?.data ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {pagestates?.isLoadingUserSalary && <BgBlurLoader />}
    </>
  );
}
